export enum VoucherEducationChoice {    
    WantsToOptOut = 0,
    WantsToLearnMore = 1,
    WantsToOptIn = 2
}